module.exports = __webpack_public_path__ + "img/rvspijpstukken2.48145d7e.png";